import { render, staticRenderFns } from "./SmallHero.vue?vue&type=template&id=ef8186b4&scoped=true"
import script from "./SmallHero.vue?vue&type=script&lang=js"
export * from "./SmallHero.vue?vue&type=script&lang=js"
import style0 from "./SmallHero.vue?vue&type=style&index=0&id=ef8186b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8186b4",
  null
  
)

export default component.exports